module.exports = __webpack_public_path__ + "img/menu-lessons.59de07f7.png";